import { Component, EventEmitter, OnInit, Output, Input, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { DialogLightComponent } from '../../../ui/dialog-light/dialog-light';

import { ApiProvider } from '../../../providers/api/api';
import { HelpersProvider } from '../../../providers/helpers/helpers';
import { AuthService } from '../../../providers/auth/auth.service';
import { CustomerProvider } from '../../../providers/customer/customer';
import { UserProvider } from '../../../providers/user/user';
import { I18nProvider } from '../../../providers/i18n/i18n';


@Component({
  selector: 'component-customer-menus',
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.scss']
})
export class CustomerMenusComponent implements OnInit {
  PAGE: any;
  STRINGS: any;
  protected headers: any;
  @Input() studentData: any = null;
  @Input() studentSelected: any = null;
  @Input() user: any = null;
  @Input() menus: any = null;

  @Output() setUserListUpdated = new EventEmitter();

  @Output() closeMenus = new EventEmitter<void>();
  modernPage = 0;
  readonly modernPageSize = 30;
  modernSearch = '';
  modernFilter = 'all';
  saving = false;
  savingMenuId: any = null;
  modernFilters = [
    {id: 'all', label: 'Todas'}, {id: 'sent', label: 'Enviadas'},
    {id: 'unsent', label: 'Não enviadas'}, {id: 'food', label: 'Por alimentos'},
    {id: 'text', label: 'Texto livre'}
  ];

  get filteredMenus(): any[] {
    const term = this.helpers.removeDiacritics(this.modernSearch.trim().toLowerCase());
    return (this.menus || []).filter(menu => {
      const name = this.helpers.removeDiacritics((this.helpers.returnTranslation(menu) || '').toLowerCase());
      return (!term || name.includes(term)) && (this.modernFilter === 'all' ||
        (this.modernFilter === 'sent' && !!menu.student) ||
        (this.modernFilter === 'unsent' && !menu.student) ||
        (this.modernFilter === 'food' && menu.type === 0) ||
        (this.modernFilter === 'text' && menu.type === 1));
    });
  }

  get modernTotalPages(): number {
    return Math.max(1, Math.ceil(this.filteredMenus.length / this.modernPageSize));
  }

  get modernCurrentPage(): number {
    return Math.min(this.modernPage, this.modernTotalPages - 1);
  }

  get pagedModernMenus(): any[] {
    const start = this.modernCurrentPage * this.modernPageSize;
    return this.filteredMenus.slice(start, start + this.modernPageSize);
  }

  changeModernPage(direction: number) {
    this.modernPage = Math.max(0, Math.min(this.modernCurrentPage + direction, this.modernTotalPages - 1));
  }

  get sentMenusCount(): number {
    return (this.menus || []).filter(menu => !!menu.student).length;
  }

  async changeModernMenu(menu: any) {
    if (this.saving || !this.studentSelected || !this.studentData) return;
    const studentId = this.studentData.id;
    const studentName = this.studentData.name;
    const wasSent = !!menu.student;
    this.saving = true;
    this.savingMenuId = menu.id;
    try {
      const response = await this.studentProv.admCustomerToggleMenu({cid: studentId, mid: menu.id});
      if (this.studentData && this.studentData.id === studentId) menu.student = wasSent ? 0 : 1;
      this.setUserListUpdated.emit(response);
      this.toastr.success((wasSent ? 'Prescrição removida de ' : 'Prescrição enviada para ') + studentName, '', this.helpers.toastrCfgs);
    } catch (error) {
      this.toastr.error('Não foi possível atualizar a prescrição. Tente novamente.', '', this.helpers.toastrCfgs);
    } finally {
      this.saving = false;
      this.savingMenuId = null;
    }
  }

  loading: boolean = false;

  totalItens2 = { count: 0 };
  maxItens2: number = 30;
  page2: number = 0;
  totalPages: number = 0;
  searchMenu: any = {
    name: <string> '',
  };
  showHistory: boolean = false;


  constructor(
    public toastr: ToastrService,
    public auth: AuthService,
    public api: ApiProvider,
    public helpers: HelpersProvider,
    public dialog: MatDialog,
    public studentProv: CustomerProvider,
    public userProv: UserProvider,
    public i18n: I18nProvider,
  ) {
    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('CustomerMenusComponent');
    this.headers = {'Authorization': `Bearer ${localStorage.getItem('LoggedInUser')}`};
  }
  ngOnInit() {
    // console.log('OnInit - componente.customer.programs');
    // console.log(this.menus);
    this.totalItens2.count = (this.menus || []).length;
    this.totalPages = Math.ceil(this.totalItens2.count/this.maxItens2);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.studentData && (!changes.studentData.previousValue || !this.studentData ||
        changes.studentData.previousValue.id !== this.studentData.id)) {
      this.modernSearch = '';
      this.modernFilter = 'all';
      this.modernPage = 0;
    }
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 400);
  }


  toggleClass(item: any) {
    item.active = !item.active;
  }

  toggleActiveMenu(id: number) {
    if (this.studentSelected) {
      // console.log('Student ID:' + this.studentForm.value.id);
      // console.log('Program ID:' + id);
      // console.log(this.studentData);
      const data = {
        cid: this.studentData.id,
        mid: id
      };
      this.studentProv.admCustomerToggleMenu(data).then(
        (res: any) => {
          // this.loading = false;
          // this.students = res.customers;
          this.setUserListUpdated.emit(res);
          this.toastr.success('('+this.studentData.name.split(' ')[0]+') ' +this.PAGE.lista_prescricoes_atualizada, '', this.helpers.toastrCfgs);
        },
        (err: any) => {
          this.toastr.error(err, '', this.helpers.toastrCfgs);
          this.loading = false;
        }
      );
    }
  }

  helpSendPrograms() {
    let msg = this.PAGE.ajuda_enviar_programas;

    const dialogRef = this.dialog.open(DialogLightComponent, { width: '360px', data: { message: msg } });
    dialogRef.afterClosed().subscribe(_result => {});
  }

  searchProgramChange() {
    this.totalPages = Math.ceil(this.totalItens2.count/this.maxItens2);
  }

  removePagination(page: number = 0) {
    const pageTarget = this.page2 - page;
    this.changePagination(pageTarget);
  }

  addPagination(page: number = 0) {
    const pageTarget = this.page2 + page;
    this.changePagination(pageTarget);
  }

  changePagination(page: number = 0) {
    this.loading = true;

    this.page2 = page;
    if (page <= 0) {
      // console.log('page <= 0');
      this.page2 = 0;
    }
    if (page >= this.totalPages) {
      // console.log('page >= this.totalPages');
      this.page2 = this.totalPages - 1;
    }

    setTimeout(() => {
      this.loading = false;
    }, 250);
  }

}
